<div class="row w-100 pt-3 text-center">
  <div class="col-12">
    <form [formGroup]="passwordForm" (submit)="savePassword()">

      <div class="form-group pb-2">
        <span class="bold-label-text float-left">Mot de passe actuel*</span>
        <input type="password" class="form-control" placeholder="Mot de passe" formControlName="password" required>
        <a href="#" id="togglePass" (click)="togglePasswordService.toggle($event)">Voir</a>
        @if (passwordFormSubmitted && passwordForm.controls.password.errors) {
          <p class="error-message">Ce champ est obligatoire</p>
        }
      </div>

      <div class="form-group pb-2">
        <span class="bold-label-text float-left">Nouveau Mot de passe*</span>
        <input type="password" minlength="8" class="form-control" placeholder="Nouveau Mot de passe" formControlName="newPassword" required>
        <a href="#" id="togglePass2" (click)="togglePasswordService.toggle($event)">Voir</a>
        @if (passwordFormSubmitted && passwordForm.controls.newPassword.errors) {
          <p class="error-message">Ce champ est obligatoire, Votre mot de passe doit contenir au moins 10 caractères, avec une majuscule, une minuscule, un chiffre et un caractère spécial</p>
        }
      </div>

      <div class="form-group pb-2">
        <span class="bold-label-text float-left">Confirmation du nouveau Mot de passe*</span>
        <input type="password" minlength="8" class="form-control" placeholder="Nouveau Mot de passe" formControlName="confirmationPassword" required>
        <a href="#" id="togglePass3" (click)="togglePasswordService.toggle($event)">Voir</a>
        @if (passwordFormSubmitted && passwordForm.controls.confirmationPassword.errors) {
          <p class="error-message">Ce champ est obligatoire, Votre mot de passe doit contenir au moins 10 caractères, avec une majuscule, une minuscule, un chiffre et un caractère spécial</p>
        }
      </div>
      <div class="cta_container">
        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
        <button type="submit" class="cta_btn level_2 column">Modifier<span></span></button>
      </div>
    </form>
  </div>
</div>
